if (!customElements.get('sp-return-link')) {
  customElements.define('sp-return-link', class extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('a');
      this.scope = this.closest('.shopify-section') || document;
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.activate = (event) => {
        const target = document.getElementById(this.dataset.targetId);
        const form = document.getElementById(this.dataset.formId);
        if (!target || !form) return;
        event.preventDefault();
        const strength = target.querySelector('[data-sp-strength-option]');
        const focus = (strength && strength.querySelector('input:checked, select')) || target.querySelector('input:checked, select') || form.querySelector('button[type="submit"]:not(:disabled)');
        target.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        if (focus) focus.focus({preventScroll: true});
      };
      this.link.addEventListener('click', this.activate);
      ['scroll', 'resize', 'pageshow'].forEach(name => window.addEventListener(name, this.schedule, {passive: true}));
      this.nodes = new MutationObserver(this.schedule);
      this.nodes.observe(this.scope, {childList: true, subtree: true});
      this.bodyClasses = new MutationObserver(this.schedule);
      this.bodyClasses.observe(document.body, {attributes: true, attributeFilter: ['class']});
      this.schedule();
    }
    update() {
      const form = document.getElementById(this.dataset.formId);
      const blocked = [...document.body.classList].some(name => name.startsWith('overflow-hidden'));
      const visible = matchMedia('(max-width: 749px)').matches && !blocked && form && form.getClientRects().length && form.getBoundingClientRect().bottom <= 0;
      this.link.hidden = !visible;
      this.syncBody();
    }
    syncBody() {
      const visible = [...document.querySelectorAll('sp-return-link a')].some(link => !link.hidden);
      if (document.body.classList.contains('sp-return-visible') !== visible) document.body.classList.toggle('sp-return-visible', visible);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      ['scroll', 'resize', 'pageshow'].forEach(name => window.removeEventListener(name, this.schedule));
      this.link.removeEventListener('click', this.activate);
      this.nodes.disconnect();
      this.bodyClasses.disconnect();
      this.syncBody();
    }
  });
}
